<div class="col-lg-12">

  <div class="card" style="width:49%;float:left;height:620px;">
  
    <!-- Alert for selecting sector and model -->
    <p class="alert alert-danger" id="successMessage" *ngIf="result.PredictError != null">
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
      {{result.PredictError}}
    </p>
  
    <p class="alert alert-danger" id="successMessage" *ngIf="result['Desc'] != null">
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
      {{result["Desc"]}}
    </p>
  
    <!--Alert  -->
  
    <h3 *ngIf="predictclick == false || result.Desc != null" class="heading2" id="titleXL" style="margin:60px 60px 40px 60px !important;">Upload the Excel File
    </h3>
    <h3 *ngIf="predictclick == true && result.Desc == null" class="heading2" id="titleXL" style="margin:60px 60px 40px 60px !important;">Download the Result
    </h3>
  
  
  
    <form *ngIf="predictclick == false || result.Desc != null" enctype="multipart/form-data" class="dropzone dz-clickable" id="dropzoneForm"
      style="width:auto;margin:0 60px !important;position:relative;" [dropzone]="config" (error)="onUploadError($event)" (success)="onUploadSuccess($event)">
      <div class="dz-default dz-message">
        <img src="./assets/static/upload.png">
        <br>
        <br>
        <span style="color:#808080 !important;">
          <b>Drag and Drop excel file here or click to browse for file</b>
        </span>
      </div>
      <div class="fallback">
  
        <!-- <input type="file" (change)="fileChange($event)"  id="btnUpload" value="Upload" class="upload" />
                  <br>
                  <input type="submit" value="Upload"> -->
      </div>
    </form>
  
    <form *ngIf="predictclick == false || result.Desc != null" (submit)="onpredict()">
      <div class="center">
          <div class="center" style="margin-top: 10px;" *ngIf="predictservice.showContraCheckBox == true"> 
              <span>
                <input data-val="true" htmlattributes="{ class = pagefield }" id="Label_Contra" [(ngModel)]="IsContraEnabled" name="IsContraEnabled" type="checkbox" value="true">
                         <span _ngcontent-c11="" style="font-size:15px;top: -5px;position: relative;margin-left: 5px;">Detect Contra entries</span>
              </span>
        </div>
        <button id="predict" type="submit" class="btn btn-lg btn-primary buttonStyle" style="margin: 10px 60px 30px 60px !important;">Predict </button>
        <!-- <button *ngIf ="!FileUploaded" id="predict" type="submit" class="btn btn-lg btn-primary buttonStyle" 
                  style="margin: 60px 60px 30px 60px !important;" disabled>Predict </button> -->
        <br />
      </div>
  
    </form>
    <div class="center">
                
      <button type="button" *ngIf="enableExcelGetLogs" (click)="OpenExcelLogsDialog()" class="btn btn-lg btn-primary buttonStyle" 
          style="margin:30px 60px 30px 60px !important;"  >
          Get Logs
      </button>
  
  </div>
    <div class="center" *ngIf="predictclick == false || result.Desc != null">
      <h5 id="text" style="text-align:center;color:#646464;">Download most recent predicted file</h5>
    </div>
    <br />
  
    <div class="center" id="btnDownload" *ngIf="predictclick == false || result.Desc != null">
      <button id="" class="btn btn-lg btn-primary buttonStyle" (click)="DownloadPredict()">
        Download Excel file</button>
    </div>
    <div *ngIf="result['Success'] != null" class="center" style="color:#2c973e !important;margin:20px 60px 20px 60px !important;font-size:16px;">
      <i class="fa fa-check"  aria-hidden="true"></i> {{result["Success"]}}
    </div>
  
    <!-- Prediction progress bar -->
    <br />
    <br />
    <br />
    <div class="center" *ngIf="predictclick == true && result.Desc == null">
      <div class="row" style="margin-right: 40px; margin-left: 40px;">
        <div class="col-xs-11">
          <div id="progress2" class="progress" style="width:100%;height:37px;margin-top:30px;">
      
            <div class="progress-bar progress-bar-striped active" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"
              style="width:100%;">
            </div>
          </div>
        </div>
      
        <div class="col-xs-1" style="height:37px;margin-top:30px;padding-left: 0px;margin-left: 0px;margin-bottom: 20px;">
          <a class="btnDel" style="cursor:pointer;" (click)="CancelPredict()">
            <i class="fa fa-close" style="font-size:36px;color:red"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="center" *ngIf="predictclick == true && result.Desc == null">
      <h5 id="text" style="text-align:center;color:#646464;">Predicting Tax codes...</h5>
    </div>
    
    <br />
    <br />
    <div class="center" *ngIf="predictclick == true && result.Desc == null">
      <h5 id="text" style="text-align:center;color:#646464;">Download most recent predicted file</h5>
    </div>
    <br />
    <!-- <div class="center" id="btnDownload" *ngIf = "predictclick == true && result.Desc == null">
              <button id="" class="btn btn-lg btn-primary buttonStyle" disabled>Download Excel file</button>
          </div> -->
    <div class="center" id="btnDownload" *ngIf="predictclick == true && result.Desc == null">
      <button id="" class="btn btn-lg btn-primary buttonStyle" (click)="DownloadPredict()">
        Download Excel file</button>
    </div>
    <!-- Prediction progress bar end -->
  
  
  </div>


  <div class="card" #TryAnother style="width:49%;float:right;height:620px;">
    <h3 class="heading2" style="margin:60px 60px 40px 60px !important;">Instant Prediction</h3>
    <p class="alert alert-danger" id="successMessage" *ngIf="Instaresult.InstantError != null">
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
      {{Instaresult.InstantError}}
    </p>

    <div style="font-size:16px !important;margin:25px 60px 40px 60px !important;color:#646464 !important;">
      <h4 id="viewVal" style="font-weight:normal;">{{Instaresult.Desc}}
        <span style="font-weight:bold !important;">{{Instaresult.DescValue}}</span>
      </h4>

      <h4 style="font-weight:normal;">{{Instaresult.Predicted}}
        <span style="font-weight:bold !important;">{{Instaresult.PredictedValue}}</span>
      </h4>
    </div>
  <div class="center">
    <a routerLink="/Predict">
      <button class="btn btn-lg btn-primary buttonStyle" style="margin: 30px 60px 30px 60px !important;">
        Try another
      </button>
    </a>
    <div class="center">
                
      <button type="button" (click)="OpenLogsDialog()" class="btn btn-lg btn-primary buttonStyle" 
          style="margin:30px 60px 30px 60px !important;"  >
          Get Logs
      </button>
    </div>
  </div>
  </div>
</div>